
document.addEventListener('DOMContentLoaded', () => {
  const downloadSection = document.getElementById('pdp-downloads');
  const gotoDownloadbtn = document.getElementById('goto-downloads');
  const shopDomain = 'halcyon-lighting.myshopify.com';
  const customerId = window.customerId || '';

  let allResources = [];
  let currentFilters = {category: 'all'};

  function getProductHandle() {
    return String(
      decodeURIComponent((window.productHandle || '').trim()),
    ).toLowerCase();
  }

  function getDownloadUrl(resourceId, shopDomain, {inline = false} = {}) {
    const params = new URLSearchParams({
      shop: shopDomain,
      resourceId: resourceId,
    });

    // For viewing PDFs inline
    if (inline) {
      params.set('inline', 'true');
    }

    // Return the URL - backend will stream the file with proper Content-Disposition
    return `/apps/halcyon-wishlist/sharepoint/download?${params}`;
  }

  // Open the PDF tab immediately. The file can keep loading there.
  function openPdfPage(url) {
    const pdfWindow = window.open('', '_blank');
    const target = pdfWindow || window;
    const safeUrl = JSON.stringify(url);
    target.document.open();
    target.document.write(
      '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Opening PDF</title><style>html,body{margin:0;height:100%;background:#fff;color:#111;font:14px/1.4 sans-serif}body{display:grid;place-items:center}</style></head><body><p>Opening PDF…</p><script>location.replace(' +
        safeUrl +
        ')<\/script></body></html>',
    );
    target.document.close();
  }

  async function fetchProductResources(options = {}) {
    const {productHandle, category = 'all', limit = 50, shopDomain} = options;
    if (!productHandle) throw new Error('Product handle is required');

    const baseParams = new URLSearchParams({
      shop: shopDomain,
      category,
      limit: limit.toString(),
    });
    const queryString = `${baseParams.toString()}&productHandle=${encodeURIComponent(productHandle)}`;
    const response = await fetch(
      `/apps/halcyon-wishlist/sharepoint/product-resources?${queryString}`,
    );

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  }

  function flattenResources(resourcesData) {
    const combined = [];
    Object.keys(resourcesData).forEach((cat) => {
      const group = resourcesData[cat] || [];
      group.forEach((res) => {
        combined.push({...res, category: cat});
      });
    });
    return combined;
  }

  function deduplicateByName(resources) {
    const seen = new Set();
    return resources.filter((resource) => {
      const nameLower = (resource.name || '').toLowerCase();
      const pathLower = (resource.folderPath || '').toLowerCase();
      
      // Create a composite key using both the path and the name
      const uniqueKey = `${pathLower}::${nameLower}`;
      
      if (seen.has(uniqueKey)) {
        return false;
      }
      seen.add(uniqueKey);
      return true;
    });
  }

  function loadResources() {
    showLoading();
    const productHandle = getProductHandle();

    if (!productHandle) {
      console.error('Product handle is missing');
      hideLoading();
      return;
    }

    fetchProductResources({shopDomain, productHandle})
      .then((data) => {
        const resourcesData = data?.data?.resourcesByCategory || {};
        const flattened = flattenResources(resourcesData);
        const deduplicated = deduplicateByName(flattened);

        const hasAnyResources = deduplicated.length > 0;
        if (downloadSection) {
          downloadSection.style.display = hasAnyResources ? 'block' : 'none';
        }
        if (gotoDownloadbtn) {
          gotoDownloadbtn.style.display = hasAnyResources ? 'flex' : 'none';
        }
        // The gallery and mobile "Jump to resources" links: clearing the inline value
        // leaves their responsive display to CSS.
        document.querySelectorAll('a[href="#pdp-downloads"]:not(#goto-downloads)').forEach((link) => {
          link.style.display = hasAnyResources ? '' : 'none';
        });

        allResources = deduplicated;

        // Init filters
        initFilterButtonToggle(resourcesData);

        // Show "no result" only if API truly returned nothing
        const noResultDiv = document.getElementById('no-result');
        if (noResultDiv) {
          noResultDiv.style.display = hasAnyResources ? 'none' : 'block';
        }

        renderResources(allResources);
        hideLoading();
      })
      .catch((err) => {
        console.error('Error loading product resources:', err);
        hideLoading();
      });
  }

  function renderResources(resources) {
    const list = document.querySelector('.product-downloads__resource');
    if (!list) return;

    const eyeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const downloadArrowSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M8 9V2" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.5 9V13H2.5V9" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.5 6.5L8 9L5.5 6.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    const spinnerSvg = `
      <svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <circle class="spinner-path" cx="6" cy="6" r="4.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="30" stroke-dashoffset="20"></circle>
      </svg>
    `;

    if (!document.querySelector('#spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'spinner-styles';
      style.textContent = `
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        .spinner { animation: spin 1s linear infinite; }
      `;
      document.head.appendChild(style);
    }

    list.innerHTML = '';

    resources.forEach((resource, index) => {
      const displayIndex = String(index + 1).padStart(3, '0');
      const div = document.createElement('div');
      div.classList.add('main-resource__row', 'resource-row');
      div.setAttribute('data-index', displayIndex);
      const formatLower = (resource.category || '').toLowerCase();
      const nameLower = (resource.name || '').toLowerCase();
      const isPdf = formatLower === 'pdf' || nameLower.endsWith('.pdf');
      const iconSvg = isPdf ? eyeSvg : downloadArrowSvg;
      const ariaLabel = isPdf
        ? `View / Save resource ${resource.name}`
        : `Download resource ${resource.name}`;
      const directUrl = resource.downloadUrl || '';
      div.innerHTML = `
        <div class="resource-row__index"><p>${displayIndex}</p></div>
        <div class="resource-row__heading"><p>${resource.name}</p></div>
        <div class="resource-row__format"><p><span>${resource.category}</span></p></div>
        <div class="resource-row__download-button">
          <button type="button" class="resource-download-button" aria-label="${ariaLabel}" data-resource-id="${resource.id}" data-format="${resource.category}" data-name="${resource.name}" data-is-pdf="${isPdf}" data-download-url="${directUrl}">
            ${iconSvg}
          </button>
        </div>
      `;
      list.appendChild(div);
    });

    document.querySelectorAll('.resource-download-button').forEach((button) => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        const resourceId = button.getAttribute('data-resource-id');
        if (!resourceId) return;

        button.disabled = true;
        button.innerHTML = spinnerSvg;
        try {
          const format = (
            button.getAttribute('data-format') || ''
          ).toLowerCase();
          const name = (button.getAttribute('data-name') || '').toLowerCase();
          const isPdf = format === 'pdf' || name.endsWith('.pdf');

          // Build the download URL - backend streams directly
          const downloadUrl = getDownloadUrl(resourceId, shopDomain, {
            inline: isPdf,
          });

          if (isPdf) {
            openPdfPage(downloadUrl);
          } else {
            window.open(downloadUrl, '_blank');
          }
        } catch (error) {
          console.error('Download failed:', error);
          alert('Failed to open file. Please try again.');
        } finally {
          button.disabled = false;
          button.innerHTML =
            button.getAttribute('data-is-pdf') === 'true'
              ? eyeSvg
              : downloadArrowSvg;
        }
      });
    });
  }

  function filterResources() {
    const noResultDiv = document.getElementById('no-result');
    let filtered = allResources;
    if (currentFilters.category !== 'all') {
      filtered = allResources.filter(
        (r) => r.category === currentFilters.category,
      );
    }

    noResultDiv.style.display = filtered.length === 0 ? 'block' : 'none';
    renderResources(filtered);
  }

  function initDownloadAllButtonAsZip() {
    const downloadAllBtn = document.querySelector(
      '.main-resource__download-all',
    );
    if (!downloadAllBtn) return;

    const downloadSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 6.75V1.5" stroke="black" stroke-linejoin="round"></path><path d="M10.125 6.75V9.75H1.875V6.75" stroke="black"></path><path d="M7.875 4.875L6 6.75L4.125 4.875" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    const spinnerSvg = `<svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle class="spinner-path" cx="6" cy="6" r="4.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="30" stroke-dashoffset="20"></circle></svg>`;

    downloadAllBtn.addEventListener('click', async () => {
      const resourceButtons = document.querySelectorAll(
        '.resource-download-button',
      );
      if (resourceButtons.length === 0) return;

      downloadAllBtn.disabled = true;
      downloadAllBtn.innerHTML = spinnerSvg;

      try {
        if (typeof JSZip === 'undefined') await loadJSZip();
        const zip = new JSZip();
        const filenameCount = {};

        await Promise.all(
          Array.from(resourceButtons).map(async (button) => {
            const resourceId = button.getAttribute('data-resource-id');
            if (!resourceId) return;
            try {
              // Build the download URL directly - backend streams the file
              const downloadUrl = getDownloadUrl(resourceId, shopDomain);
              const response = await fetch(downloadUrl);
              let filename = button.getAttribute('data-name');
              const contentDisp = response.headers.get('content-disposition');
              if (!filename && contentDisp?.includes('filename')) {
                filename = contentDisp
                  .split('filename=')[1]
                  .replace(/["']/g, '');
              }
              if (!filename) {
                filename =
                  decodeURIComponent(
                    downloadUrl.split('/').pop().split('?')[0],
                  ) || `file_${Date.now()}`;
              }
              const baseName = filename.replace(/(\.[^.]*)$/, '');
              const ext = filename.match(/(\.[^.]*)$/)?.[0] || '';
              if (filenameCount[filename]) {
                filenameCount[filename]++;
                filename = `${baseName} (${filenameCount[filename]})${ext}`;
              } else {
                filenameCount[filename] = 1;
              }
              const blob = await response.blob();
              zip.file(filename, blob);
            } catch (error) {
              console.error(`Failed for resource ${resourceId}:`, error);
            }
          }),
        );

        const content = await zip.generateAsync({type: 'blob'});
        const url = URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = `resources_${Date.now()}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('ZIP download failed:', error);
      } finally {
        downloadAllBtn.disabled = false;
        downloadAllBtn.innerHTML = `${downloadSvg} Download All`;
      }
    });

    function loadJSZip() {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src =
          'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }

  function initFilterButtonToggle(resourcesData = {}) {
    document
      .querySelectorAll('.product-downloads__filters--button')
      .forEach((btn) => {
        const filterValue = btn.getAttribute('data-filter') || 'all';
        if (filterValue !== 'all') {
          const group = Array.isArray(resourcesData[filterValue])
            ? resourcesData[filterValue]
            : [];
          if (group.length === 0) {
            btn.style.display = 'none';
            return;
          } else {
            btn.style.display = '';
          }
        }
        btn.addEventListener('click', function () {
          if (currentFilters.category === filterValue) return;
          currentFilters.category = filterValue;
          document
            .querySelectorAll('.product-downloads__filters--button')
            .forEach((b) => b.classList.remove('active'));
          this.classList.add('active');
          filterResources();
        });
      });
  }

  function showLoading() {
    document
      .querySelector('.product-downloads__loading')
      ?.classList.remove('hidden');
    document
      .querySelector('.product-downloads__resource')
      ?.classList.add('hidden');
  }

  function hideLoading() {
    document
      .querySelector('.product-downloads__loading')
      ?.classList.add('hidden');
    document
      .querySelector('.product-downloads__resource')
      ?.classList.remove('hidden');
  }

  // Make the whole resource row clickable, delegated so it keeps working
  // after renderResources() re-renders the list (filters, reloads, etc).
  document.addEventListener('click', (e) => {
    const row = e.target.closest(
      '.product-downloads__resource .resource-row',
    );
    if (!row) return;
    if (e.target.closest('.resource-download-button')) return;
    row.querySelector('.resource-download-button')?.click();
  });

  initDownloadAllButtonAsZip();
  initFilterButtonToggle();
  loadResources();

  // Listen for product section replacement events
  document.addEventListener('productSectionsReplaced', async (event) => {
    if (!event.detail?.productHandle) {
      console.error(
        'Product handle missing from productSectionsReplaced event',
      );
      return;
    }

    // 🔧 Get resource identifier from the data attribute on the section
    const downloadSection = document.getElementById('pdp-downloads');
    const resourceIdentifier = downloadSection?.getAttribute(
      'data-resource-identifier',
    );

    if (!resourceIdentifier) {
      console.error('Unable to determine resource identifier from section');
      return;
    }

    // 🔧 Update window.productHandle with the resource identifier from the section
    window.productHandle = resourceIdentifier;
    console.log('Updated window.productHandle to:', window.productHandle);

    // Reset filters to 'all'
    currentFilters = {category: 'all'};

    // Reset active filter button
    document
      .querySelectorAll('.product-downloads__filters--button')
      .forEach((btn) => {
        if (btn.getAttribute('data-filter') === 'all') {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

    // Reload resources with new product handle
    loadResources();
  });
});
